module.exports = __webpack_public_path__ + "logo-omie-mobile.png";